import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const AccountsLegacyRedirect = lazy(() =>
  import("@scenes/Accounts").then((module) => ({
    default: module.AccountsLegacyRedirect,
  }))
);

export const AccountsNRO: NavigationRoutingObject = {
  Component: AccountsLegacyRedirect,
  componentFeatureFlippers: ["accounts_nro_component"],
  section: "data-settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("accounts-nro-heading", "Accounts"),
  pageNameForTracking: () => "Accounts",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("accounts-nro-description", "Manage account data, such as prospects and customers"),
  icon: "nav-system-accounts",
  tag: "beta",
  getDeveloperNavigationAllowed: ({ featureOn }) => featureOn("accounts_nro_component"),
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/dashboard/accounts/:appGroupId",
};
